import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from '../Modal';
import * as modal from '../../reducers/modalReducer';
import RaisedButton from 'material-ui/RaisedButton';
import * as userReducer from '../../reducers/userReducer';
import { reset } from '../../reducers/addressReducer';
import * as page from '../../reducers/pageReducer';
import { HeaderDiv, TextDiv } from '../../modals';
import styled from 'styled-components';
import { NEGATIVE_COLOR } from '../../config/colors';
import './style.css'
import { reset as resetProducts } from '../../actions/product';

const styles = {
  labelStyle: { fontWeight: 700 },
}
class LogOutFormModal extends Component {

  onCloseRequest = () => {
    this.props.hideModal();
  }

  handlePositiveClick = () => {
    this.props.hideModal();
    this.props.hidePage();
  }

  handleNegativeClick = () => {
    /* sign off the user */
    this.props.logoff();
    this.props.clearDeliveryAddresses();
    this.props.invalidateUser();
    this.props.reset();
    this.props.hideModal();
    this.props.hidePage();
    this.props.onClose();
  }

  render() {
    return (
      <Modal overlayTop={0} closeOnOutsideClick={true} isOpened={true} onClose={this.onCloseRequest}>
        <div className="logout-form">
            <HeaderDiv>LOG OUT</HeaderDiv>
            <TextDiv>Are you sure you want to logoff?</TextDiv>
            <ButtonsWrapperDiv>
              <RaisedButton
                  onClick={this.handlePositiveClick}
                  backgroundColor={NEGATIVE_COLOR}
                  labelColor="#FFF"
                  label="GO SHOP"
                  labelStyle={styles.labelStyle}
                />
              <RaisedButton
                  onClick={this.handleNegativeClick}
                  backgroundColor={`#` + this.props.secondaryColor}
                  labelColor="#FFF"
                  label="YES"
                  labelStyle={styles.labelStyle}
                />
            </ButtonsWrapperDiv>
        </div>
       </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    primaryColor: state.config.primaryColor,
    secondaryColor: state.config.secondaryColor,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearDeliveryAddresses: () => dispatch(reset()),
    logoff: () => dispatch(userReducer.logOff()),
    hideModal: () => dispatch(modal.hideModal()),
    hidePage: () => dispatch(page.hidePage()),
    invalidateUser: () => dispatch(userReducer.invalidateUser()),
    reset: () => dispatch(resetProducts()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LogOutFormModal);

const ButtonsWrapperDiv = styled.div `
  display: flex;
  justify-content: space-between;
  width: 200px;
`;



// WEBPACK FOOTER //
// ./src/components/LogOutFormModal/LogOutFormModal.jsx